"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _combineReducers2 = require("./combineReducers");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a ReduxStore with a given preloadedState, reducers, middlewares, or thunk extraArgument`
 *
 * Also adds a `__unbindExternals` method to the store to allow unbinding of external reducer events
 * @param preloadedState
 * @param reducerMap
 * @param middlewares
 * @param extraArgument
 * @return {(Store<any, Action> & {dispatch: any}) | *}
 */
var createStore = function (_ref) {
  var preloadedState = _ref.preloadedState,
      reducerMap = _ref.reducers,
      middlewares = _ref.middlewares,
      extraArgument = _ref.extraArgument;

  if (!middlewares) {
    middlewares = extraArgument ? [_reduxThunk.default.withExtraArgument(extraArgument)] : [_reduxThunk.default];
  }

  if (typeof reducerMap !== 'object') {
    // if reducers is passed in already-combined, just use it
    return (0, _redux.createStore)(reducerMap, preloadedState, _redux.applyMiddleware.apply(void 0, middlewares));
  }

  var _combineReducers = (0, _combineReducers2.combineReducers)(reducerMap, function () {
    return store;
  }),
      reducers = _combineReducers.reducers,
      unbindExternals = _combineReducers.unbindExternals;

  var store = (0, _redux.createStore)(reducers, preloadedState, _redux.applyMiddleware.apply(void 0, middlewares));
  store.__unbindExternals = unbindExternals;
  return store;
};

var _default = createStore;
exports.default = _default;